module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-183.7e2f057b.svg";